import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const MobileStickyCTA = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Hide on the Contact page itself — no point sending the user where they already are.
  if (location.pathname === "/contacto") return null;

  return (
    <div style={styles.bar} data-testid="mobile-sticky-cta">
      <Link
        to="/contacto"
        style={styles.button}
        data-testid="mobile-sticky-cta-button"
      >
        {t("mobileCta.button")}
        <ArrowRight size={18} style={{ marginLeft: 8 }} />
      </Link>
    </div>
  );
};

const styles = {
  bar: {
    display: "none",
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    padding: "12px 16px calc(12px + env(safe-area-inset-bottom))",
    background: "rgba(255, 255, 255, 0.92)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
    boxShadow: "0 -6px 24px rgba(0, 0, 0, 0.06)",
    zIndex: 90
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "14px 20px",
    fontSize: "16px",
    fontWeight: 600,
    color: "#ffffff",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "999px",
    textDecoration: "none",
    boxShadow: "0 8px 20px rgba(102, 126, 234, 0.35)"
  }
};

// Show only on mobile + add bottom padding so content isn't covered.
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @media (max-width: 1024px) {
    [data-testid="mobile-sticky-cta"] {
      display: block !important;
    }
    body {
      padding-bottom: 88px;
    }
  }
`;
document.head.appendChild(styleSheet);

export default MobileStickyCTA;
